import { render, staticRenderFns } from "./getOwner.vue?vue&type=template&id=ec55be28&scoped=true&"
import script from "./getOwner.vue?vue&type=script&lang=js&"
export * from "./getOwner.vue?vue&type=script&lang=js&"
import style0 from "./getOwner.vue?vue&type=style&index=0&id=ec55be28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec55be28",
  null
  
)

export default component.exports